const SkeletonRoot = [
// Position
'relative',
// Layout
'overflow-hidden',
// Box
'p-0',
// Borders
'border-0',
// Theme
'bg-skeletons-gradient', 'dark:bg-skeletons-gradient-dark',
// Background
'bg-repeat'];
const SkeletonTextContainerRoot = [
// Layout
'flex', 'flex-col',
// Box
'h-auto'];
const SkeletonCircle = [
// Box
'rounded-full'];
const SkeletonRect = [
// Box
'rounded-md'];
const SkeletonText = [
// Box
'w-full', 'rounded-md'];
const SkeletonAnimated = [
// Background
'bg-[length:200%]',
// Animation
'animate-skeleton-loader'];

export { SkeletonRoot as S, SkeletonCircle as a, SkeletonAnimated as b, SkeletonRect as c, SkeletonTextContainerRoot as d, SkeletonText as e };
